import { render, staticRenderFns } from "./BsCardMedia.vue?vue&type=template&id=1d0e0616&"
import script from "./BsCardMedia.vue?vue&type=script&lang=js&"
export * from "./BsCardMedia.vue?vue&type=script&lang=js&"
import style0 from "./BsCardMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports